import { h, Component, cloneElement } from 'preact'
import { Text } from 'preact-i18n'

export default class Panel extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selected: this.props.selected || 0
        }
    }

    componentWillReceiveProps({selected}) {
        if (this.props.selected != selected) 
            this.setState({selected})
    }

    selectTab (index) {
        this.setState(({selected}) => {
            let next = selected == index ? -1 : index
            this.props.onChange && this.props.onChange(next)
            return {
                selected: next
            }
        })
    }

    render ({children = []}, { selected }) {
        return (
            <div class="limba__panel">
                {children.map((child, i) => cloneElement(child, {
                    onSelect: () => this.selectTab(i),
                    hidden: i != selected
                }))}
            </div>
        )
    }
}

Panel.Tab = class extends Component {
    componentDidMount() {
        if (this.props.hidden) {
            $(this.contentEl).hide()
        } else {
            $(this.contentEl).show()
        }
    }

    componentWillReceiveProps({hidden}) {
        if (this.props.hidden != hidden) {
            if (hidden)
                $(this.contentEl).slideUp()
            else
                $(this.contentEl).slideDown()
        }
    }

    render ({ heading, children, onSelect, hidden }) {
        return (
            <div class="limba__panel-tab">
                <div class="limba__panel-tab-heading" onClick={onSelect}><Text id={heading} /><span class={hidden ? 'konf-icon-Add' : 'konf-icon-Remove'}></span></div>
                <div class="limba__panel-tab-content" ref={el => this.contentEl = el}>{children}</div>
            </div> 
        )
    }
}



// WEBPACK FOOTER //
// ./js/components/Panel.js